module.exports = __webpack_public_path__ + "img/globe.521fdd15.svg";